import { render, staticRenderFns } from "./PushSettings.vue?vue&type=template&id=ab59c3b6&scoped=true"
import script from "./PushSettings.vue?vue&type=script&lang=js"
export * from "./PushSettings.vue?vue&type=script&lang=js"
import style0 from "./PushSettings.vue?vue&type=style&index=0&id=ab59c3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab59c3b6",
  null
  
)

export default component.exports